import React from 'react';
import PropTypes from 'prop-types';
import validator from 'validator';
import moment from 'moment';
import { Card, Message, Grid, Divider, Icon } from 'semantic-ui-react';
import _ from 'lodash';
import HorizontalCollaborationCard from '../../components/horizontal-collaboration-card';
import { getInfluencerFromOrganisations } from '../../utils/helper-functions';

const h5DescriptionStyle = {
  paddingBottom: 15,
};

const groupStyle = {
  marginBottom: 15,
};

const messageStyle = { margin: '0px 10px' };
const HIDE_BROKEN_INFLUENCERS = true;

const InfluencerGroupByStatus = ({
  title,
  description,
  discussions,
  emptyText,
  campaign,
  getInvitationStatus,
  reviewMode,
}) => {
  const liveDate = campaign.get('liveDate');
  const endDate = campaign.get('endDate');

  const startMoment = moment(liveDate);
  const endMoment = moment(endDate);
  const today = moment();

  const hasStarted = startMoment.isValid() ? today.isSameOrAfter(startMoment) : false;
  const hasEnded = endMoment.isValid() ? endMoment.isBefore(today) : false;

  const isLiveCampaign = (hasStarted && !hasEnded);

  return (
    <div style={groupStyle}>
      <Grid fluid>
        <Grid.Row>
          <Grid.Column width={3}>
            <h3>{title}</h3>
            <h5 style={h5DescriptionStyle}>{description}</h5>
          </Grid.Column>
          <Grid.Column width={13} verticalAlign="middle">
            {
              _.isEmpty(discussions) && (
                <Message fluid style={messageStyle}>
                  <p>{emptyText}</p>
                </Message>
              )
            }
            {
              !_.isEmpty(discussions) &&
              <Card.Group itemsPerRow="one">
                {
                  _.map(discussions, discussion => {
                    const influencer = discussion.influencer
                    || getInfluencerFromOrganisations(discussion.organisations);

                    const isEmailValid = validator.isEmail(influencer && influencer.email ? influencer.email : '');
                    const invitationStatus = getInvitationStatus({ discussion });
                    const discussionName = discussion.name;

                    const assets = _.compact(_.get(discussion, 'trackedAssets', []));
                    const manualStories = _.size(_.filter(assets, ['assetType', 'STORY']));

                    const stories = _.size(_.compact(_.get(discussion, 'stories', [])));

                    const totalStories = _.add(stories, manualStories);
                    const totalAssets = _.size(_.uniqBy(_.reject(assets, ['assetType', 'STORY']), 'assetId'));

                    const campaignJSON = campaign.toJSON();
                    const rollfwdCampaign = campaignJSON.rollfwdCampaign;

                    const influencerProps = _.pick(influencer, [
                      'email',
                      'primarySocialHandle',
                      'thumbnail',
                      'instagramStatus',
                      'facebookStatus',
                      'twitterStatus',
                      'youtubeStatus',
                      'instagramPrivate',
                      'facebook',
                      'instagram',
                      'youtube',
                      'twitter',
                      'tiktok',
                      'telegramChannels',
                      'usageRightsGranted',
                      'discountCode',
                    ]);

                    const derivedProps = {
                      discussionId: discussion.id,
                      discussionName,
                      campaignId: campaign.get('id'),
                      campaignWorkflow: campaign.get('workflow'),
                      influencerName: _.get(influencer, 'name', ''),
                      rollfwdCampaign,
                      reviewMode,
                      isEmailValid,
                      invitationStatus,
                      totalAssets,
                      totalStories,
                      ...influencerProps,
                      lastScannedDate: discussion.lastScannedDate,
                      lastSuccessfulStoryScan: discussion.lastSuccessfulStoryScan,
                      isLiveCampaign,
                      hasPosted: _.get(discussion, 'hasPosted', false),
                      instagramScanFailures: _.get(discussion, 'instagramScanFailures', 0),
                      isScanningCompleted: _.get(discussion, 'isScanningCompleted'),
                      internalDiscountCode: _.get(discussion, 'internalDiscountCode'),
                      workflowStatus: _.get(discussion, 'workflowStatus'),
                    };

                    if (influencer) {
                      return <HorizontalCollaborationCard {...derivedProps} />;
                    }

                    if (!HIDE_BROKEN_INFLUENCERS) {
                      return (
                        <Card color="red">
                          <Card.Content>
                            <table>
                              <tr>
                                <td style={{ width: 50, textAlign: 'center' }}>
                                  <Icon name="warning circle" color="red" size="big" />
                                </td>
                                <td>
                                  <h4>Broken Influencer</h4>
                                  <h5 style={{ color: 'grey' }}>{derivedProps.discussionName}</h5>
                                </td>
                              </tr>
                            </table>
                          </Card.Content>
                        </Card>
                      );
                    }
                  })
                }
              </Card.Group>

            }
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Divider />
    </div>
  );
};

InfluencerGroupByStatus.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  campaign: PropTypes.object.isRequired,
  emptyText: PropTypes.string.isRequired,
  getInvitationStatus: PropTypes.func.isRequired,
  discussions: PropTypes.array,
};

InfluencerGroupByStatus.defaultProps = {
  discussions: [],
};

export default InfluencerGroupByStatus;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-group/index.js
 **/